import cx from 'classnames'
import { useContext, useMemo } from 'react'

import {
  type Step,
  type StepDefinition,
  getStepDefinitions,
} from '../../lib/step-definition'
import { FrameBuilderValidationContext } from '../../contexts/validation-context'

import InfoBalloon from '../info-balloon'

interface PreviewsProps {
  activeStep: Step | null
  showExtrasStep: boolean
  onPreviewClick: (step: Step) => void
  className?: string
}

const Previews = ({
  activeStep,
  showExtrasStep,
  onPreviewClick,
  className,
}: PreviewsProps) => {
  const { frameCompletionPercentage } = useContext(
    FrameBuilderValidationContext,
  )

  const stepDefinitions = useMemo<StepDefinition[]>(() => {
    return getStepDefinitions(showExtrasStep)
  }, [showExtrasStep])

  return (
    <div
      className={cx(
        'grow-0 shrink-0 w-full transition-all duration-200',
        {
          '-ml-[100%]': activeStep !== null,
        },
        className,
      )}
    >
      {stepDefinitions.map((stepDefinition) => (
        <stepDefinition.previewComponent
          key={stepDefinition.step}
          number={stepDefinition.number}
          onClick={onPreviewClick}
        />
      ))}

      <InfoBalloon
        withGraphic={frameCompletionPercentage === 100}
        className="flex-1"
      />
    </div>
  )
}

export default Previews
